const {
  VITE_APP_ENV: APP_ENV,
  VITE_APP_BASE_URL: BASE_URL,
  VITE_SUPPORT_URL: SUPPORT_URL,
  VITE_SKILLWEB_HOST: SKILLWEB_HOST,
  VITE_LAUNCH_DARKLY_CLIENT_ID: LAUNCH_DARKLY_CLIENT_ID,
  VITE_SENTRY_DSN: SENTRY_DSN,
  VITE_NODE_ENV: NODE_ENV,
  VITE_BUILD_VERSION: BUILD_VERSION,
  VITE_BUILD_TIME: BUILD_TIME,
  VITE_SKILL_TERMS_OF_USE_URL: SKILL_TERMS_OF_USE_URL,
  VITE_SKILL_PRIVACY_POLICY_URL: SKILL_PRIVACY_POLICY_URL,
  VITE_SKILL_SOCIAL_MEDIA_LINKEDIN: SKILL_SOCIAL_MEDIA_LINKEDIN,
  VITE_SKILL_EXTERNAL_CATALOG_URL: SKILL_EXTERNAL_CATALOG_URL,
  VITE_VIACEP_BASE_URL: VIACEP_BASE_URL,
  VITE_IFRAME_RESIZER_KEY: IFRAME_RESIZER_KEY,
  VITE_RECAPTCHA_SITE_KEY: RECAPTCHA_SITE_KEY,
  VITE_SKILL_EXPLORER_CATALOG_BASE_URL: SKILL_EXPLORER_CATALOG_BASE_URL,
  VITE_IDLE_CANCELLATION_KNOW_MORE_URL: IDLE_CANCELLATION_KNOW_MORE_URL
} = import.meta.env

export const settings = {
  BUILD_VERSION,
  BUILD_TIME: new Date(BUILD_TIME),
  NODE_ENV,
  APP_ENV,
  BASE_URL,
  SUPPORT_URL,
  SKILLWEB_HOST,
  LAUNCH_DARKLY_CLIENT_ID,
  SENTRY_DSN,
  SKILL_TERMS_OF_USE_URL,
  SKILL_PRIVACY_POLICY_URL,
  SKILL_SOCIAL_MEDIA_LINKEDIN,
  SKILL_EXTERNAL_CATALOG_URL,
  VIACEP_BASE_URL,
  IFRAME_RESIZER_KEY,
  RECAPTCHA_SITE_KEY,
  SKILL_EXPLORER_CATALOG_BASE_URL,
  IDLE_CANCELLATION_KNOW_MORE_URL
}
